import { Pipe, PipeTransform } from '@angular/core';
import { Indicador } from '../../modelos/indicador';

@Pipe({
  name: 'filtroIndicadores'
})
export class FiltroIndicadoresPipe implements PipeTransform {

  transform(indicadores: Indicador[], filtro?: string): any {
    if (indicadores === undefined || filtro === undefined || filtro.trim() === '') {
      return indicadores;
    }
    filtro = filtro.toLocaleLowerCase();
    return indicadores.filter(indicador => indicador.nomeIndicador.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-indicadores.pipe.ts